import { createAction } from 'redux-actions';
import {addStickerItem} from "../sticker-show/actions";
import { batchActions } from "redux-batched-actions";
import { restoreCachedSticker, setScannedStickerItem } from "../create-llama/actions";
import { push } from "connected-react-router";
import { draftStickerSelector } from "./selectors";
import cacheManager from '../../domain/services/StickerCache';

const namespace = 'DRAFTS';

export const setDraftContinueModalVisibility = createAction(`${namespace}/SET_DRAFT_CONTINUE_MODAL_VISIBILITY`);
export const setDraftSticker = createAction(`${namespace}/SET_TARGET_STICKER`);

export function checkStickerDraft() {
  return (dispatch, getState) => {
    const stickerId = location.pathname.split('/')[1];
    const invalidKeys = ['/', 'login', 'register', 'new', 'stickers', '', 'scan-sticker', 'business'];
    const isStickerIdValid = !invalidKeys.some((k) => k === stickerId);
    if (isStickerIdValid) {
      dispatch(addStickerItem(stickerId));
    }
  };
}

export function showContinueOrFreshModal(draftSticker) {
  return (dispatch, getState) => {
    dispatch(batchActions([
      setDraftContinueModalVisibility(true),
      setDraftSticker(draftSticker),
      restoreCachedSticker(draftSticker)
    ]));
  };
}

export function startFreshSticker() {
  return (dispatch, getState) => {
    const draftSticker = draftStickerSelector(getState());
    const scannedSticker = draftSticker.stickerState.scannedSticker;
    const stickerId = scannedSticker.sticker_id;
    cacheManager.removeCachedSticker(stickerId);
    dispatch(batchActions([
      setScannedStickerItem(scannedSticker),
      setDraftContinueModalVisibility(false),
      setDraftSticker(null),
      push(`/stickers/${stickerId}/new`)
    ]));
  };
}

export function continueDraft() {
  return (dispatch, getState) => {
    dispatch(batchActions([
      setDraftContinueModalVisibility(false),
      setDraftSticker(null),
    ]));
  };
}
